import { ContentItem } from 'kentico-cloud-delivery';
import { get } from 'lodash';

export default class Panel extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`
    });
  }

  get id() {
    return this.system.id;
  }

  get title() {
    return get(this, '_naglowek.value');
  }

  get description() {
    return get(this, '_tresc.value');
  }

  get file() {
    return get(this, '_dokument.value');
  }
}



// WEBPACK FOOTER //
// ./src/models/Panel.model.js